import { CHECKING_RATES, POST_FILTER_RATES } from '../actions/actionTypes';

const DEFAULT_STATE = {
  loading: false,
};

export const ratesReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case CHECKING_RATES:
      return {
        ...state,
        loading: true,
      };

    case POST_FILTER_RATES:
      return {
        ...state,
        lenders: action.payload,
        loading: false,
      };

    default:
      return {
        ...state,
      };
  }
};
